module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aps"
  }, [_c('div', {
    staticClass: "sitecontent"
  }, [_c('div', {
    staticClass: "inr_banner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "npagePage introduction"
  }, [_c('div', {
    staticClass: "intro_cont"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "intro_tab-content tab-content"
  }, [_c('div', {
    staticClass: "intro_panel-01"
  }, [_c('div', {
    staticClass: "tab-pane_na wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("面向普通外卖商户")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "clearfix text_cont"
  }, [_c('img', {
    staticClass: "fl",
    attrs: {
      "src": "/static/img/appimg1.jpg",
      "alt": "自动接单打印机"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text_div text1 fl text_fr"
  }, [_c('p', [_vm._v("众联云打印机提供众联云助手，商户购买打印机后，轻松即可绑定店铺。")]), _vm._v(" "), _c('p', [_vm._v("支持以下平台：")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/appimg3.jpg",
      "alt": "平台外卖接单"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane_na mt20"
  }, [_c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("面向软件开发商")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "clearfix text_cont wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    staticClass: "fl",
    attrs: {
      "src": "/static/img/appimg2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text_div text3 fl text_fr"
  }, [_c('p', [_c('span', [_vm._v("1")]), _vm._v("众联云开放平台对外开放API接口，给开发人员带来了极大的方便，只需30分钟即可完成对接，API接口支持PHP、Java、NodeJS等语言;\n                                            ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("2")]), _vm._v("软件开发商对接打印机时，免费给客户提供技术支持;\n                                            ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("3")]), _vm._v("打印机可自定义打印内容和格式，支持二维码、条形码、LOGO打印等；\n                                            ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("4")]), _vm._v("提供网页版开发者中心，轻松管理订单与机器。\n                                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane_na mt20"
  }, [_c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("场景案例展示")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "clearfix text_cont"
  }, [_c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg1.jpg",
      "alt": "餐饮打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("餐饮店：外卖后厨小票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_vm._v("\n                                                打印机支持多种餐饮软件，一台打印机完成多个平台订单\n                                                "), _c('br'), _vm._v("无需连接电脑、手机、蓝牙，节约成本压力\n                                                "), _c('br'), _vm._v("自动接单、自动打印，真正省时省力省心\n                                                "), _c('br'), _vm._v("打印机放在前台和后厨能同时出单，更加便利高效\n                                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg2.jpg",
      "alt": "收银台打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("收银台：超市小票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("\n                                                打印机能对接云收银系统，即插即用\n                                                "), _c('br'), _vm._v("打印机只需连接WiFi或GPRS网络，无需配备电脑，节省成本\n                                                "), _c('br'), _vm._v("自动打印订单功能，进一步提升收银效率\n                                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "clearfix text_cont",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg3.jpg",
      "alt": "药店打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("药店：药品小票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("\n                                                打印机是药店经营的得力帮手，使用中需要接入小票打印机\n                                                "), _c('br'), _vm._v("无需配备电脑，节省成本，提供用户销售凭证\n                                                "), _c('br'), _vm._v("自动打印订单功能，快速结账\n                                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg4.jpg",
      "alt": "加油站打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("加油站：订单发票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_vm._v("\n                                                扫码加油，手机支付，自动打印小票\n                                                "), _c('br'), _vm._v("无需下车，既可完成加油，极大提高司机加油体验。\n                                            ")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8363dda4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aps.vue
// module id = 343
// module chunks = 1